import { gql } from '@apollo/client';

const COMPLETE_RMA_TICKET = gql`
  mutation completeRmaTicket($input: CompleteRmaTicketInput) {
    completeRmaTicket(input: $input) {
      isSuccess
      message
    }
  }
`;

export default COMPLETE_RMA_TICKET;
